import moment from "moment";
import Badge from 'react-bootstrap/Badge';
import { mensajeSimple } from "../components/ui/sweetAlerts";
import jwtDecode from "jwt-decode";

const returnNombreIndex = (modulo, perfil) => {
  let txt = "";
  if (["2"].includes(modulo)) {
    txt = ["4"].includes(perfil) ? "Iniciar Solicitud" : "Solicitudes en curso";
  }
  if (["1"].includes(modulo)) {
    txt = "Solicitudes en progreso"
  }
  return txt;
}

export const returNombreRuta = (path) => {
  if (path.includes('/vacante')) { return 'Información de la vacante'; }
  else if (path.includes('/editar-vacante')) { return 'Edición de solicitud'; }
  else if (path.includes('/detalle-vacante')) { return 'Historial de solicitud'; }

  return ({
    '/': returnNombreIndex(localStorage.getItem('modulo'), localStorage.getItem('id_perfil')),
    '/listSolicitudReingreso': 'Solicitudes de reingreso',
    '/solicitudes-en-curso': 'Solicitudes de curso',
    '/consulta-rut': 'Consulta RUT',
    '/firma-contrato': 'Documentos a revisar',
    '/resumen-solicitudes': 'Resumen de solicitudes',
    '/monitor': 'Monitor',
    '/log-temporis': 'Log de temporis',
    '/envio-sap': 'Envío a SAP',
    '/ajustes-de-dias': "Ajustes de días",
    '/envio-a-sap': "Envío a SAP",
    '/solicitud-desvinculacion': "Solicitud de desvinculación",
    '/desvinculacion-colaborador': "Desvinculación colaborador",
    '/historial-solicitudes': "Historial de solicitudes",
    '/solicitudes-traspaso': "Solicitudes de traspaso",
    '/monitor-firma': 'Monitor webdox',
    '/monitor-confirmalo': 'Monitor confirmalo',
    '/formulario-contratacion': 'Nueva solicitud'
  }[path] || '');
}

export const devolverPlural = obj => obj.idContrato.length > 1 ? 's' : '';

export const cerrarSession = () => {
  const url = localStorage.getItem("url_intranet");
  localStorage.clear();
  window.location = url.endsWith("/") ? url + "home" : url + "/home";
}

// Esta función se encarga de calcular el promedio de los porcentajes de avance de los documentos
// que se encuentran en el array arrDocumentos. Primero, verifica si el array está vacío y, si es así, devuelve 0.
// Si no está vacío, suma los porcentajes de avance de cada documento y calcula el promedio dividiendo
export const promedioStatusContrato = (arrDocumentos) => {
  if (!arrDocumentos || !Array.isArray(arrDocumentos)) return 0;
  let sumaPorcentajeStatus = 0;
  let cantidadDocumentos = arrDocumentos.length;

  //si arrDocumentos es 0, no se hace nada
  if (cantidadDocumentos === 0) {
    return 0;
  }
  // Si es mayor a 0, se hace suman los porcentajes para calcular el promedio
  arrDocumentos.forEach((documento) => {
    sumaPorcentajeStatus += documento.porcentaje_avance;
  });

  // Se calcula el promedio dividiendo la suma de porcentajes por la cantidad de documentos
  const promedio = sumaPorcentajeStatus / cantidadDocumentos;
  // Se redondea el promedio a 2 decimales
  const promedioRedondeado = Math.round(promedio * 100) / 100;
  // Se devuelve el promedio redondeado
  return promedioRedondeado;
}

export const momentFecha = (txt) => moment(txt).format('DD-MM-yyyy');

export const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son de 0-11
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

export const fechaMinimaHasta = (fecha) => (moment(fecha).add(1, 'y').format('yyyy-MM-DD')).toString()

export const evaluarEstado = (estado, perfil, idBotton) => {
  let visible = false;
  switch (idBotton) {
    case '1':
      visible = true;
      break;
    case '3':
      if ((estado === 5) && (perfil === '4')) { visible = true; }
      break;
    case '2':
      if (
        (estado === 9 || estado === 3 || estado === 8 || estado === 4 || estado === 6 || estado === 12) &&
        (perfil === '2' || perfil === '3')) {
        visible = true;
      }
      break;
    case '4':
      if (estado <= 12 || estado === 17) {
        visible = true;
      }
      break;
    case '5':
      if (
        (estado === 9 || estado === 3 || estado === 8 || estado === 4 || estado === 6 || estado === 12) &&
        (perfil !== '4')) {
        visible = true;
      }
      break;
    case '6':
      if ((estado === 7 || estado === 10) && (perfil === '4')) { visible = true; }
      break;
    case '7':
      if ((estado === 13) && (perfil === '3')) { visible = true; }
      break;
    case '50':
      if ((estado === 7 || estado === 10) && (perfil === '4')) { visible = true; }
      break;
    default:
      break;
  }
  return visible;
}

export const getBusinessDaysAgo = (daysAgo = 0) => {
  let currentDate = moment();
  const curretDateNoChange = moment();
  let daysRemaining = daysAgo;
  while (daysRemaining > 0) {
    currentDate = currentDate.subtract(1, 'days');
    daysRemaining--;
  }
  //aca voy a valiar que la fecha No sea de un mes distinto al actual
  if (currentDate._d.getMonth() !== curretDateNoChange._d.getMonth()) {
    //en caso de ser distinto devuelvo el primer dia del mes...
    return moment(curretDateNoChange).startOf('month');
  }

  return currentDate;
}

export const evaluarEstadoBadge = (estado) => {
  let badge = {};
  switch (estado) {
    case 1:
      badge = <Badge pill bg="success">Exitoso</Badge>;
      break;
    case 2:
      badge = <Badge pill bg="danger">Fallido</Badge>;
      break;
    case 3:
      badge = <Badge pill bg="warning">Reintentado</Badge>;
      break;
    default:
      badge = <Badge pill bg="danger">Fallido</Badge>;
      break;
  }
  return badge;
}

export const capitalizeFirstLetter = (str) => {
  return str.split(' ')
    // Transformar cada palabra para que su primera letra sea mayúscula y el resto minúscula
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    // Unir las palabras transformadas de nuevo en un string
    .join(' ');
}

export function formatearYExtraerCrearColaborador(xmlString) {
  // Parsear el XML
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, "application/xml");

  // Buscar el elemento CrearColaborador
  const crearColaborador = xmlDoc.getElementsByTagName("CrearColaborador")[0];
  const resultado = [];

  if (crearColaborador) {
    Array.from(crearColaborador.children).forEach((elemento, index) => {
      // Envolver el nombre del nodo en un elemento <strong> para aplicar el efecto de negrita
      resultado.push(
        <span key={Number.parseInt(index)}>
          <strong>{elemento.nodeName}</strong>: {elemento.textContent ? elemento.textContent : "N/A"}
        </span>
      );

      // Añadir un <br /> después de cada elemento, excepto el último
      if (index < crearColaborador.children.length - 1) {
        resultado.push(<br key={`br-${Number.parseInt(index)}`} />);
      }
    });
  } else {
    resultado.push("Elemento <CrearColaborador> no encontrado.");
  }

  return resultado;
}
export const returnAnio = fecha => (new Date(fecha)).getFullYear();

export const getNumerosEnCadena = async (string) => {
  let tmp = string.split(" ");

  // Usamos filter directamente. Si devuelve true, se queda. Si false, se va.
  let numbers = tmp.filter((current) => {
    return !isNaN(parseFloat(current));
  });

  return numbers[0] || '45';
}

export const validaGetStatus = (code) => {
  const objMensaje = {
    401: "La sessión ha expirado",
    500: "No se ha podido guardar"
  }

  if ([200].includes(code) || ["object"].includes(typeof code)) {
    return true;
  }

  mensajeSimple('error', objMensaje[code]);
  return false
}

export const formatFecha = (txt) => {
  const fechaStr = txt.toString().replaceAll('-', '');

  const anio = fechaStr.substring(0, 4);
  const mes = fechaStr.substring(4, 6);
  const dia = fechaStr.substring(6, 8);

  return `${dia}-${mes}-${anio}`;
}

export const cierraModal = (path = "button.btn-close") => {
  document.querySelector(path).click();
}

export function soloNumero(txt) {
  return txt.replace(/[^0-9]/g, '').slice(0, 3);
}

export const getNumerosEnCadena_2 = txt => {
  const opciones = ["15", "30", "20", "22,5", "41", "42"];

  // Busca el primer elemento que esté incluido en el texto
  const encontrado = opciones.find(el => txt.includes(el));

  return encontrado || '45';
}

export const hideSideBarDesktop = () => {
  if (document.querySelector("#offcanvasExample").classList.contains("show")) {
    document.querySelector("#sideBarBtn").click();
  }
}

export const returnMayus = (txt) => {
  if (!txt) return "";
  const tSplt = txt.split(" ");
  let res = "";
  if (tSplt[0]) res += tSplt[0].charAt(0).toUpperCase() + tSplt[0].slice(1);
  if (tSplt[1]) res += " " + tSplt[1].charAt(0).toUpperCase() + tSplt[1].slice(1);
  return res.trim();
}

export const cerrarSessionModal = () => {
  mensajeSimple("error", "La sesión ha caducado.", 3000);
  setTimeout(() => cerrarSession(), 3000);
}

export const returnModuloNombre = (modulo) => {
  const obj = {
    '1': "Contratación RED",
    '2': "Cambios contractuales",
    '3': "Cambios contractuales",
  }
  return obj[modulo] || '';
}

export const tokenExpirado = (token) => {
  if (!token) return true;
  try {
    const decoded = jwtDecode(token);
    const dateNow = new Date();
    return decoded.exp * 1000 < dateNow.getTime();
  } catch (error) {
    console.log("Error al decodificar el token:", error);
    return true;
  }
}


export const formatRUT = e => {
  const str = e.replace(/[.-]/g, '');
  const formateado = new Intl.NumberFormat("de-DE").format(str.slice(0, -1).replace(',', '.'))
  return `${formateado}-${str.slice(-1)}`;
}